import { render, staticRenderFns } from "./BannedHeader.vue?vue&type=template&id=4918351c&scoped=true&"
import script from "./BannedHeader.vue?vue&type=script&lang=js&"
export * from "./BannedHeader.vue?vue&type=script&lang=js&"
import style0 from "./BannedHeader.vue?vue&type=style&index=0&id=4918351c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4918351c",
  null
  
)

export default component.exports